import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Body1, HeaderBlock } from '@fs/zion-ui'
import Head, { Title } from '@fs/zion-head'
import PersonPageBanner from '@fs/tree-person-page-banner'
import PersonNotFound from './PersonNotFound.svg'

const imageCss = css`
  background-image: url(${PersonNotFound});
  background-color: #c4c4c4;
  background-position: center bottom;
  background-size: contain;
  background-repeat: no-repeat;
  height: 100vh;
`
const errorCss = css`
  text-align: center;
  margin-top: 50px;
`

const person = {
  name: undefined,
  gender: 'UNKNOWN',
}

export default function GoneError(): JSX.Element {
  const [t] = useTranslation()

  return (
    <div css={imageCss}>
      <Head>
        <meta httpEquiv="status" content="410 Gone" />
      </Head>
      <Title>{`${t('ancestors.error-page.meta-data.title')} | ${t('ancestors.gone-error.header')}`}</Title>
      <PersonPageBanner person={person} notFound />
      <div data-testid="gone-error" css={errorCss}>
        <HeaderBlock heading={t('ancestors.gone-error.header')} size="md" />
        <Body1>{t('ancestors.gone-error.text')}</Body1>
      </div>
    </div>
  )
}
